import { useTranslation } from 'react-i18next';

import { IconDirDown, IconDirUp } from '../Icon';
import { SrOnly } from '../SrOnly';
import { Actions, Btn, Order, Wrapper } from './wrapper';

export interface SortActionsProps {
  sortOrder?: string | number;
  disabledUp?: boolean;
  disabledDown?: boolean;
  horizontal?: boolean;
  onClickUp?: () => void;
  onClickDown?: () => void;
}

const SortActions = ({
  sortOrder,
  disabledUp,
  disabledDown,
  horizontal,
  onClickUp,
  onClickDown,
}: SortActionsProps) => {
  const { t } = useTranslation(['common', 'other']);

  return (
    <Wrapper>
      <Actions $horizontal={horizontal}>
        <Btn
          $horizontal={horizontal}
          onClick={onClickUp}
          title={t('moveUp', { ns: 'common' }) || ''}
          disabled={disabledUp}
        >
          <IconDirUp />
        </Btn>
        <Btn
          $horizontal={horizontal}
          onClick={onClickDown}
          title={t('moveDown', { ns: 'common' }) || ''}
          disabled={disabledDown}
        >
          <IconDirDown />
        </Btn>
      </Actions>
      {sortOrder && (
        <Order>
          <SrOnly>{t('sortOrder', { ns: 'other' })}: </SrOnly>
          {sortOrder}
        </Order>
      )}
    </Wrapper>
  );
};

export default SortActions;
